import { render, staticRenderFns } from "./LessonQuizPreview.vue?vue&type=template&id=c458da20"
import script from "./LessonQuizPreview.vue?vue&type=script&lang=js"
export * from "./LessonQuizPreview.vue?vue&type=script&lang=js"
import style0 from "./LessonQuizPreview.vue?vue&type=style&index=0&id=c458da20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports